export default import.meta.ROLLDOWN_FILE_URL_TCu_VQ9gb0SMB9N6E0hofg